export const ApplicationConstant = {
    ApplicationID : 24,
    clientId : 14,
    organizationId: 60,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD',
    KWAppID: 23
}